<div class="main-container">
  <div class="verification-content verification-title">
    <h1 appConfigSettingsTitle>
      {{ "IdinVerificationCancelledPage.Title" | translate }}
    </h1>
  </div>
  <mat-divider></mat-divider>
  <div class="verification-content" appConfigSettingsParagraph>
    <p>
      {{ "IdinVerificationCancelledPage.CancelledMessage" | translate }}
    </p>
    <p class="margin-bottom">
      {{ "IdinVerificationCancelledPage.SecondCancelledMessage" | translate }}
    </p>
  </div>
  <mat-divider></mat-divider>
  <p class="margin-above"></p>
  <div class="full-width buttonCenteredContainer button-center">
    <button mat-button appConfigSettingsButton (click)="calculationPage()">
      {{ "IdinVerificationCancelledPage.TryAgainButton" | translate }}
    </button>
  </div>
</div>
